<div class="container">
  <mat-card appearance="outlined">
    <mat-card-title class="btn btn-rose">
      Edit Purchase Order Detail For Po: {{ poNumber }}
    </mat-card-title>

    <mat-card-content>
      <form *ngIf="editPoDetailsForm" [formGroup]="editPoDetailsForm" (ngSubmit)="updatePoDetails()" novalidate>
        <div class="row">

          <!-- Order Quantity -->
          <div class="col-md-3">
            <mat-form-field appearance="fill" color="accent">
              <mat-label>Order Quantity</mat-label>
              <input
                matInput
                type="number"
                placeholder="Order Quantity"
                formControlName="orderQuantity"
                min="1"
                required
                appInputValidator
              />
              <mat-error *ngIf="editPoDetailsForm.get('orderQuantity').hasError('required')">
                Order Quantity is required.
              </mat-error>
              <mat-error *ngIf="editPoDetailsForm.get('orderQuantity').hasError('min')">
                Order Quantity must be at least 1.
              </mat-error>
              <mat-error *ngIf="editPoDetailsForm.get('orderQuantity').hasError('max')">
                Order Quantity must not exceed 90000.
              </mat-error>
            </mat-form-field>
          </div>

          <!-- Warranty In Months -->
          <div class="col-md-3">
            <mat-form-field appearance="fill" color="accent">
              <mat-label>Warranty In Months</mat-label>
              <input
                matInput
                type="number"
                placeholder="Warranty In Months"
                formControlName="warrantyInMonths"
                required
                appInputValidator
              />
              <mat-error *ngIf="editPoDetailsForm.get('warrantyInMonths').hasError('required')">
                Warranty is required.
              </mat-error>
              <mat-error *ngIf="editPoDetailsForm.get('warrantyInMonths').hasError('min')">
                Cannot be negative.
              </mat-error>
              <mat-error *ngIf="editPoDetailsForm.get('warrantyInMonths').hasError('max')">
                Must be less than or equal to 60 months.
              </mat-error>
            </mat-form-field>
          </div>

          <!-- Unit Price -->
          <div class="col-md-3">
            <mat-form-field appearance="fill" color="accent">
              <mat-label>Unit Price</mat-label>
              <input
                matInput
                type="number"
                placeholder="Unit Price"
                formControlName="unitPrice"
                required
                appInputValidator
              />
              <mat-error *ngIf="editPoDetailsForm.get('unitPrice').hasError('required')">
                Unit Price is required.
              </mat-error>
              <mat-error *ngIf="editPoDetailsForm.get('unitPrice').hasError('min')">
                Unit Price cannot be negative.
              </mat-error>
            </mat-form-field>
          </div>

          <!-- Measuring Unit -->
          <div class="col-md-3" *ngIf="units.length > 0">
            <mat-form-field appearance="fill" color="accent">
              <mat-label>UOM</mat-label>
              <mat-select formControlName="measuringUnitId" required>
                <mat-option [value]="null">Select an option</mat-option>
                <mat-option *ngFor="let unit of units" [value]="unit.measuringUnitId">
                  {{ unit.unitName }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="editPoDetailsForm.get('measuringUnitId').hasError('required')">
                UOM is required.
              </mat-error>
            </mat-form-field>
          </div>

        </div>
      </form>
    </mat-card-content>

    <!-- Footer Buttons -->
    <mat-card-footer *ngIf="editPoDetailsForm">
      <div class="row action-btn justify-content-center">
        <button
          mat-raised-button
          type="button"
          class="btn btn-rose"
          (click)="close()"
        >
          Close
        </button>

        <button
          mat-raised-button
          type="submit"
          class="btn btn-rose"
          [disabled]="
            !editPoDetailsForm.valid ||
            editPoDetailsForm.get('unitPrice')?.value < 0 ||
            editPoDetailsForm.get('warrantyInMonths')?.value < 0
          "
        >
          Update
        </button>
      </div>
    </mat-card-footer>
  </mat-card>
</div>
